import { Box, Typography, Chip, Avatar } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { InfoCard } from './InfoCard';
import type { Vehicle } from '../../context/VehicleContext';
import { VEHICLE_TYPE_TRANSLATIONS } from '../../constants/vehicleConstants';

interface VehicleInfoProps {
  vehicle: Vehicle;
}

export function VehicleInfo({ vehicle }: VehicleInfoProps) {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, background: '#F8FAFF', borderRadius: 3, p: 2 }}>
        <Avatar 
          src={vehicle.foto} 
          sx={{ width: 48, height: 48, bgcolor: '#6366F1' }}
        >
          <DirectionsCarIcon sx={{ fontSize: 28, color: 'white' }} />
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Chip label="Veículo" color="primary" size="small" variant="outlined" />
            {vehicle.tenantName && (
              <Typography color="#6B7280" fontSize={14}>
                {vehicle.tenantName}
              </Typography>
            )}
          </Box>
          <Typography variant="h6" fontWeight={700} color="#23272E" mb={0.5}>
            {vehicle.marca} {vehicle.modelo}
          </Typography>
          <Typography color="#6B7280" fontSize={14}>
            Placa: {vehicle.placa} • Ano: {vehicle.ano} • Cor: {vehicle.cor}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mb: 3 }}>
        <InfoCard label="Marca" value={vehicle.marca} />
        <InfoCard label="Modelo" value={vehicle.modelo} />
        <InfoCard label="Tipo" value={VEHICLE_TYPE_TRANSLATIONS[vehicle.tipo] || vehicle.tipo} />
        <InfoCard 
          label="Placa" 
          value={vehicle.placa} 
          customValue={
            <Typography component="span" sx={{ fontFamily: 'monospace', backgroundColor: '#E5E7EB', color: '#111827', px: 2, py: 0.5, borderRadius: 2, fontSize: 16, display: 'inline-block', fontWeight: 700 }}>
              {vehicle.placa}
            </Typography>
          }
        />
        <InfoCard label="Ano" value={vehicle.ano.toString()} />
        <InfoCard label="Cor" value={vehicle.cor} />
        {vehicle.observacoes && (
          <InfoCard label="Observações" value={vehicle.observacoes} />
        )}
      </Box>
    </>
  );
} 